import { render, staticRenderFns } from "./DataFilter.vue?vue&type=template&id=4b65e6b8&scoped=true"
import script from "./DataFilter.vue?vue&type=script&lang=js"
export * from "./DataFilter.vue?vue&type=script&lang=js"
import style0 from "./DataFilter.vue?vue&type=style&index=0&id=4b65e6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b65e6b8",
  null
  
)

export default component.exports